import { ReferrerAccountStatus } from "@redotech/crdb-enums/referrals/referrer-account-status";
import { ReferrerAccountType } from "@redotech/crdb-enums/referrals/referrer-account-type";
import * as z from "zod";

export const REFERRER_TYPES = Object.values(ReferrerAccountType);
export const REFERRER_STATUSES = Object.values(ReferrerAccountStatus);

type ReferrerType = `${ReferrerAccountType}`;
type ReferrerStatus = `${ReferrerAccountStatus}`;
const referrerTypeSchema: z.ZodType<ReferrerType, ReferrerType> =
  z.enum(ReferrerAccountType);
const referrerStatusSchema: z.ZodType<ReferrerStatus, ReferrerStatus> = z.enum(
  ReferrerAccountStatus,
);

export const ReferrerSummarySchema = z.object({
  id: z.string(),
  email: z.email(),
  name: z.string(),
  referralCode: z.string(),
  profileImageUrl: z.string().url().nullable(),
  referrerType: referrerTypeSchema,
  status: referrerStatusSchema,
});

export type ReferrerSummary = z.infer<typeof ReferrerSummarySchema>;
